<template>
    <div class="modal fade " id="sendProductArtworkToVendor">
        <div class="modal-dialog  modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info">
                    <h5 class="modal-title">Send Customer Art To Vendor</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div class="form-group">
                        <v-select label="text" :filterable="false" :multiple="false"
                                  v-model="selectedVendors"
                                  :options="vendors"
                                  @search="onVendorSearch"
                                  @input="onVendorSelect"
                                  @selected="onVendorSelect"
                                  @deselected ="onVendorDeSelect">
                            <template slot="no-options">
                                type to search vendors..
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center" v-html="option.html">
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center" v-html="option.text">
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label for="subject">Subject</label>
                        <input type="text" class="form-control" id="subject" placeholder="" v-model="subject">

                        <div class="d-flex justify-content-between mt-1">
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addCC" v-on:click="toggleCC"><span class="lt-bl-bg"> {{isCC ? 'Remove CC' : 'Add CC'}}</span></a>
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addBCC" v-on:click="toggleBCC"><span class="lt-bl-bg"> {{isBCC ? 'Remove BCC' : 'Add BCC'}}</span></a>
                        </div>
                    </div>

                    <div class="form-group" v-if="isCC == true">
                        <label for="cc">CC</label>
                        <!--<input type="email" class="form-control" id="cc" placeholder="cc" v-model="cc">-->
                        <InputTag v-model="cc" id="cc" placeholder="Comma separated CC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag>
                    </div>


                    <div class="form-group" v-if="isBCC == true">
                        <label for="bcc">BCC</label>
                        <!--<input type="email" class="form-control" id="bcc" placeholder="bcc" v-model="bcc">-->
                        <InputTag v-model="bcc" id="bcc" placeholder="Comma separated BCC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag>
                    </div>


                    <div class="form-group textarea-box1">
                        <!--<label for="message_body">Hello</label>-->
                        <ckeditor v-model="message_body"
                                  tag-name="textarea"
                                  value="Hello, <p>Please Enter Message</p>"
                                  :config="editorConfigMin"></ckeditor>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label>Add Attachment</label> <br>
                            <vue-dropzone :options="dropzoneOptions"
                                          :id="'item-dropzone-attach'"
                                          ref="sendArtToVendorDropzone"
                                          v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                            </vue-dropzone>
                        </div>
                        <div class="col-12" v-if="vendor_files.length > 0">
                            <template v-for="(item, index) in vendor_files">
                                <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                    {{item.name}}
                                    <span class="orderbtnsec">
                                        <a :href="item.src" target="_blank">
                                            Download</a>
                                    </span>
                                    <a href="javascript:void(0)" class="trash_btn"
                                       @click="deleteAttachFile(index, item)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                </div>
                            </template>
                        </div>

                        <div class="col-12">
                            <template v-if="is_one_artwork_for_all && order.original_customer_file">
                                <div class="pdf-dwn-sec line-hgt">
                                    {{order.original_customer_file}}
                                    <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="downloadOriginalArtwork(order.original_customer_file)">
                                            Download</a>
                                    </span>
                                </div>
                            </template>

                            <template v-if="is_one_artwork_for_all == false && product != null && product.original_customer_file">
                                <div class="pdf-dwn-sec line-hgt">
                                    {{product.original_customer_file}}
                                    <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="downloadOriginalArtwork(product.original_customer_file)">
                                            Download</a>
                                    </span>
                                </div>
                            </template>
                        </div>

                    </div>

                    <div class="mt-3">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary close-modal" v-on:click="sendToVendor">Send Mail</button>
                    </div>

                </div>



            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import InputTag from "vue-input-tag";

export default {
    name: "SendProductArtworkToVendor",
    components: {
        DatePicker,
        vueDropzone: vue2Dropzone,
        InputTag
    },
    props: ['order', 'product', 'artwork', 'is_one_artwork_for_all', 'po'],
    created() {

    },
    beforeMount() {
        this.getSendToCustomerSettings();
    },
    mounted() {
        let self = this;
        $('#sendProductArtworkToVendor').on('hidden.bs.modal', function () {
            self.getSendToCustomerSettings();
        });

        $('#sendProductArtworkToVendor').on('show.bs.modal', function () {
            self.getSendToCustomerSettings();

            let pos = [];

            if(self.po) {
                pos.push(self.po);
            } else {
                if(self.order && self.order.purchase_orders && self.order.purchase_orders.length) {
                    pos = self.order.purchase_orders.filter((x) => x.vendor);
                }
            }

            if(pos.length) {
                self.getVendors(pos[0].vendor);
            } else {
                if(self.is_one_artwork_for_all) {
                    let products = self.order.products.filter((x) => x.quote_product);
                    if(products.length) {
                        self.getQuotation(products[0].quote_product.quote_id);
                    }

                } else if(self.product && self.product.quote_product) {
                    self.getQuotation(self.product.quote_product.quote_id);
                }
            }

        });



    },
    data() {
        return {
            submitted: false,
            isCC: false,
            media_ids: [],
            cc: [],
            isBCC: false,
            bcc: [],
            subject: `Artwork for order ${this.order.order_number}`,
            message_body: "Hello, <p>Please Enter Message</p>",
            adminUser: null,
            smtp_user: null,
            vendors: [],
            selectedVendors: null,
            vendor_id: null,
            vendor_files: [],
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 5,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder'
        ]),
        getQuotation(id = null) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('PriceCalculationPage', {id: id, version: null}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        if(data.data.vendor_mail_list && data.data.vendor_mail_list.length) {
                            let vendor = data.data.vendor_mail_list[0];
                            vendor.id = vendor.vendor_id;
                            self.getVendors(vendor);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSendToCustomerSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.sendToCustomer.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.adminUser = data.data.adminUser;
                        this.smtp_user = data.data.smtp_user;
                        this.subject = `Artwork for order ${this.order.order_number}`;
                        this.message_body = data.data.so_send_to_customer_body;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        sendToVendor() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('orders.sendArtworksToVendor', {id: this.order.id}), {
                subject: this.subject,
                cc: this.cc,
                bcc: this.bcc,
                message_body: this.message_body,
                media_ids: this.media_ids,
                isCC: this.isCC,
                isBCC: this.isBCC,
                product_id: this.product ? this.product.id : null,
                is_one_artwork_for_all: this.is_one_artwork_for_all,
                selectedVendors: this.selectedVendors,
                vendor_id: this.vendor_id
            }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.$emit('vendorEmailSentEvent', data.data);
                        self.setSuccessMessage(data.message);
                        $('#sendProductArtworkToVendor').modal('hide');
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteAttachFile(index, item){
            this.$refs.sendArtToVendorDropzone.removeFile(item.file);
            this.vendor_files.splice(index, 1);
            this.media_ids.splice(index, 1);
        },
        afterUploadComplete(file, response) {
            //this.media_id = response.data.media.id;
            this.vendor_files.push({
                id: response.data.media.id,
                name: response.data.media.filename,
                file_size: response.data.media.file_size,
                src: response.data.url,
                file_type: response.data.media.file_type,
                file_ext: response.data.media.file_ext,
                original_file_name: response.data.media.original_file_name,
                file: file
            });
            this.media_ids.push(response.data.media.id);
        },
        toggleCC(){
          this.isCC = !this.isCC;
            if(!this.isCC) {
                this.cc = [];
            }
        },
        toggleBCC(){
            this.isBCC = !this.isBCC;
            if(!this.isBCC) {
                this.bcc = [];
            }
        },

        onVendorSelect(event){
            //console.log('onVendorSelect',event)
            this.vendor_id = event.id;
        },
        onVendorDeSelect(event){
            //console.log('onVendorDeSelect',event)
            this.vendor_id = null;

        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendorNew(loading, search, this);
            }
        },
        getVendors(vendor){
            this.setLoading(true);
            axios.post(window.route('searchVendors'), {searchTerm: vendor.company_name}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        this.vendors = data.data;
                        let vendors = this.vendors.filter((x) => {
                            let ids = x.id.split('-');
                            return ids.length && ids[0] == vendor.id;
                        });
                       if(vendors.length) {
                           this.selectedVendors = vendors[0];

                           this.vendor_id = vendor.id;
                       }
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    this.setLoading(false);
                });
        },
        searchVendorNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchVendors'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.vendors = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        downloadOriginalArtwork(original_customer_file) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: this.order.id,
                name: original_customer_file,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", original_customer_file);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
